import React, {
  useEffect,
  useImperativeHandle,
  useState,
  forwardRef,
} from "react";

const DetailsForm = forwardRef(
  (
    {
      disableAllFields,
      fields,
      stateData,
      mandatoryFields,
      setStateData,
      setDisable,
      onErrorChange,
      errors = {},         // add errors prop with default
      licenseState,
      setLicenseState
    },
    ref
  ) => {
    const [error, setError] = useState({});    

    const validateField = (value, required = false, pattern, message) => {
      if (!value.trim()) {
        return required ? message : "";
      }
      if (!pattern) return "";
      return pattern.test(value) ? "" : message;
    };

    const handleInputChange = (e, pattern, message) => {
      const { name, value } = e.target;
      const errorMsg = validateField(
        value,
        mandatoryFields?.includes(name),
        pattern,
        message
      );
        let newValue = value;

      if(name === "licenceNumber"){
        setLicenseState("")
      }
      // Convert YYYY-MM-DD to MM/DD/YYYY for consistency
  if (e?.target?.type === "date" && value) {
    const [year, month, day] = value.split("-");
    newValue = `${month}/${day}/${year}`;
  }

      setStateData((prevDetails) => ({
        ...prevDetails,
        [name]: newValue,
      }));

      setError((prevErrors) => {
        const newErrors = {
          ...prevErrors,
          [name]: errorMsg,
        };
        onErrorChange && onErrorChange(newErrors);
        return newErrors;
      });
    };

    const handleBlur = (e, pattern, message) => {
      const { name, value } = e.target;
      const errorMsg = validateField(
        value,
        mandatoryFields?.includes(name),
        pattern,
        message
      );

      setError((prevErrors) => {
        const newErrors = {
          ...prevErrors,
          [name]: errorMsg,
        };
        onErrorChange && onErrorChange(newErrors);
        return newErrors;
      });
    };

    useImperativeHandle(ref, () => ({
      validateAllFields: () => {
        const newErrors = {};
        fields.forEach((field) => {
          const value = stateData[field.name] || "";
          const errorMsg = validateField(
            value,
            mandatoryFields?.includes(field.name),
            field.pattern,
            field.message
          );
          if (errorMsg) {
            newErrors[field.name] = errorMsg;
          }
        });
        setError(newErrors);
        onErrorChange && onErrorChange(newErrors);
        return newErrors;
      },
      resetValidation: () => {
        setError({});
        onErrorChange && onErrorChange({});
      },
    }));

    useEffect(() => {
      const requiredFieldsFilled = mandatoryFields?.every((fieldName) => {
        return stateData[fieldName]?.trim();
      });
      const hasNoErrors = Object.values(error).every((e) => !e);
      setDisable(!(requiredFieldsFilled && hasNoErrors));
    }, [stateData, error]);

    const handleKeyDown = (e) => {
      const allowedKeys = [
        "Backspace",
        "ArrowLeft",
        "ArrowRight",
        "Tab",
        "Delete",
      ];
      if (!/^\d$/.test(e.key) && !allowedKeys.includes(e.key)) {
        e.preventDefault();
      }
    };

    // Use errors prop if available, fallback to internal error state
    const displayErrors = Object.keys(errors).length ? errors : error;

const formatDateMMDDYYYY = (dateStr) => {
  if (!dateStr) return "";
  const [month, day, year] = dateStr.split("/");
  return `${year}-${month?.padStart(2, "0")}-${day?.padStart(2, "0")}`;
};

    return (
      <>
        {fields?.map((field) => (
          <div key={field.name} className="row mb-3 align-items-center">
            <label htmlFor={field.name} className="col-6 col-sm-6 col-lg-3 buyeragentform-label">
              {field.label}{" "}
              <span className="mandatory">
                {mandatoryFields?.includes(field.name) && "*"}
              </span>
            </label>
            <div className=" col-6">
              <input
                className={`form-control h-25 buyeragentform-input ${
                  displayErrors[field.name] ? "error-border" : ""
                }`}
                type={field?.type}
                aria-label={field?.name}
                placeholder={field.placeholder}
                name={field?.name}
                value={                  
                  field.type === "date"
                    ? stateData?.[field.name]
                      ? formatDateMMDDYYYY(stateData[field.name])
                      : ""
                    : stateData[field.name] || ""
                }
                disabled={disableAllFields?.includes(field?.name)}
                onChange={(e) => handleInputChange(e, field.pattern, field.message)}
                maxLength={field?.maxLength ? field?.maxLength : ""}
                onKeyDown={
                  field.name === "phone" ||
                  field.name === "titleInsPhone" ||
                  field?.name === "closingAgentPhone"
                    ? handleKeyDown
                    : undefined
                }
                min={field?.type === "date" ? new Date().toISOString().split("T")[0] : undefined}
                onBlur={(e) => handleBlur(e, field.pattern, field.message)}
              />
              {field?.name === "licenceNumber" && !displayErrors[field.name] && (
                <p className="license-pendig-agent"> {licenseState}</p>
              )}
              {displayErrors[field.name] && (
                <p className="error-offer">{displayErrors[field.name]}</p>
              )}
            </div>
          </div>
        ))}
      </>
    );
  }
);


export default DetailsForm;
